function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.4615 10.5C11.5435 10.5 10.663 10.1313 10.0139 9.47487C9.3647 8.8185 9 7.92826 9 7C9 6.07174 9.3647 5.1815 10.0139 4.52513C10.663 3.86875 11.5435 3.5 12.4615 3.5H18V0.7C18 0.514348 17.9271 0.336301 17.7972 0.205025C17.6674 0.0737499 17.4913 0 17.3077 0H0.692308C0.508696 0 0.332605 0.0737499 0.202772 0.205025C0.0729393 0.336301 0 0.514348 0 0.7V13.3C0 13.4857 0.0729393 13.6637 0.202772 13.795C0.332605 13.9263 0.508696 14 0.692308 14H17.3077C17.4913 14 17.6674 13.9263 17.7972 13.795C17.9271 13.6637 18 13.4857 18 13.3V10.5H12.4615Z",
  fill: "#CACAF1"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.0383 5.70744C11.5205 5.34577 12.1743 5.14258 12.8563 5.14258H17.9991V8.99972H12.8563C12.1743 8.99972 11.5205 8.79653 11.0383 8.43485C10.5561 8.07318 10.2852 7.58264 10.2852 7.07115C10.2852 6.55966 10.5561 6.06912 11.0383 5.70744ZM13.4994 7.71401C13.8545 7.71401 14.1423 7.42619 14.1423 7.07115C14.1423 6.71611 13.8545 6.42829 13.4994 6.42829C13.1444 6.42829 12.8566 6.71611 12.8566 7.07115C12.8566 7.42619 13.1444 7.71401 13.4994 7.71401Z",
  fill: "#CACAF1"
});

var SvgWallet = function SvgWallet(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWallet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wallet.d5dd9232.svg";
export { ForwardRef as ReactComponent };